<!-- =========================================================================================
  File Name: StudentView.vue
  Description: Student View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="student-view-tab-info">
    <!-- Avatar Row -->
    <div class="vx-row">
      <div class="mb-4 vx-col w-full">
        <div class="flex items-start flex-col sm:flex-row">
          <img :src="student_data.photo" class="mr-8 rounded h-24 w-24" />
          <!-- <vs-avatar :src="data.avatar" size="80px" class="mr-4" /> -->
          <div>
            <p class="text-lg font-medium mb-2 mt-4" sm:mt-0>{{ student_data.name  }}({{ student_data.studentID  }})</p>
            <!-- <input type="file" class="hidden" ref="update_avatar_input" @change="update_avatar" accept="image/*"> -->

            <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
            <!-- <vs-button class="mr-4 mb-4">변경</vs-button> -->
            <!-- <vs-button type="border" class="mr-4" @click="$refs.update_avatar_input.click()">Change Avatar</vs-button> -->

            <!-- <vs-button type="border" color="danger">삭제</vs-button> -->
            <div class="vx-row">
              <vs-button class="mr-4 mb-4 ml-4" icon-pack="feather" icon="icon-edit" :to="{name: 'student-edit', params: { studentID: $route.params.studentID }}">수정</vs-button>
              <!-- <vs-button type="border" class="mb-4" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">퇴교</vs-button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Content Row -->
    <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">
          <table>
            <tr>
              <td class="font-semibold">학년구분</td>
              <td>{{ schoolType }} / {{ schoolGrade  }}</td>
            </tr>
            <tr>
              <td class="font-semibold">학교명</td>
              <td>{{ student_data.schoolName  }}</td>
            </tr>
            <tr>
              <td class="font-semibold">학생 휴대폰번호</td>
              <td>{{ student_data.mobilephone }}</td>
            </tr>
            <tr>
              <td class="font-semibold">모 휴대폰번호</td>
              <td>{{ student_data.motherMobile  }}</td>
            </tr>
            <tr>
              <td class="font-semibold">부 휴대폰</td>
              <td>{{ student_data.fatherMobile  }}</td>
            </tr>
            <tr>
              <td class="font-semibold">전화번호</td>
              <td>{{ student_data.telephone }}</td>
            </tr>
            <tr>
              <td class="font-semibold">생년월일</td>
              <td>{{ student_data.birthDay  }} ({{ isLunar }}) ({{ gender }})</td>
            </tr>
            <tr>
              <td class="font-semibold">우편번호</td>
              <td>{{ student_data.zipCode }}</td>
            </tr>
            <tr>
              <td class="font-semibold">주소</td>
              <td>{{ student_data.zipName }}</td>
            </tr>
            <tr>
              <td class="font-semibold">주소세부</td>
              <td>{{ student_data.zipDetail  }}</td>
            </tr>
          </table>
        </div>

        <div class="vx-col md:w-1/2 w-full">
          <table>
            <!-- <tr>
              <td class="font-semibold">Class 정보</td>
              <td>{{ student_data.classSeq  }}</td>
            </tr> -->
            <tr>
              <td class="font-semibold">교사</td>
              <td></td>
            </tr>
            <!-- <tr>
              <td class="font-semibold">수납 SMS</td>
              <td></td>
            </tr> -->
            <tr>
              <td class="font-semibold">메모1</td>
              <td>{{ student_data.memo1  }}</td>
            </tr>
            <tr>
              <td class="font-semibold">메모2</td>
              <td>{{ student_data.memo2 }}</td>
            </tr>
            <tr>
              <td class="font-semibold">입학일</td>
              <td>{{ student_data.schoolEnterDate  }}</td>
            </tr>
            <tr>
              <td class="font-semibold">퇴교일</td>
              <td>{{ student_data.schoolLeaveDate }}</td>
            </tr>
            <tr>
              <td class="font-semibold">상태</td>
              <td>{{ status }}</td>
            </tr>
            <tr>
              <td class="font-semibold">수강권한</td>
              <td :class="licenseYnTextColor">{{ licenseYn }}</td>
            </tr>
            <tr>
              <td class="font-semibold">담당강사</td>
              <td>{{ student_data.teacherID }}</td>
            </tr>
          </table>
        </div>
    </div>
    <!-- Save&Delete Button -->
    <!-- <div class="vx-row">
      <div class="vx-col w-full">
        <div class="flex flex-wrap items-center justify-end">
          <vs-button icon-pack="feather" icon="icon-edit" class="mr-2" :to="{name: 'student-edit', params: { studentID: $route.params.studentID }}">수정</vs-button>
          <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">퇴교</vs-button> 
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { putData } from '@/api/module'

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      student_data: JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    schoolType () {
      const schoolType = this.student_data.schoolType
      if (schoolType === 0) {
        return '초등'
      } else if (schoolType === 1) {
        return '중등'
      } else if (schoolType === 2) {
        return '고등'
      } else {
        return ''
      }
    },
    schoolGrade () {
      return `${ this.student_data.schoolGrade + 1 }학년`
    },
    isLunar () {
      if (this.student_data.isLunar === 0) {
        return '양력'
      } else {
        return '음력'
      }
    },
    gender () {
      if (this.student_data.gender === 0) {
        return '남'
      } else {
        return '여'
      }
    },
    status () {
      if (this.student_data.status === 0) {
        return '정상'
      } else {
        return '퇴교'
      }
    },
    licenseYn () {
      if (this.student_data.licenseYn === 'Y') {
        return '가능'
      } else {
        return '불가능'
      }
    },
    licenseYnTextColor () {
      if (this.student_data.licenseYn === 'Y') {
        return 'text-primary'
      } else {
        return 'text-danger'
      }
      
    }
  },
  methods: {
    confirmDeleteRecord () {
      // console.log(`퇴교`);
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '퇴교 처리',
        text: `"${this.student_data.studentID} (을/를) 퇴교 처리하시겠습니까?"`,
        accept: this.deleteRecord,
        acceptText: '퇴교'
      })
    },
    async deleteRecord () {
      try {
        const studentData = {
          status: 1,
          studentID: this.student_data.studentID
        }
        const {data} = await putData('student/status', studentData)
        this.$vs.loading.close()
        console.log(data)
        this.$router.push('/student/student-list')
        // const studentID = this.student_data.studentID;
        // this.$router.push(`/student/student-view/${studentID}`);
        // this.$emit('refresh');
        this.showDeleteSuccess()

      } catch (error) {
        // console.log(error.response.data.msg);
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: '퇴교 처리',
        text: '퇴교 처리 되었습니다.'
      })
    }
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-student-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

}

</style>
